import React, { useState } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import Box from 'transfix-ui/core/Box'
import {
  GetNormFileGeneratorStatusesQueryParams,
  NormFileGeneratorStatus,
  useGetNormFileGeneratorStatuses,
  NormFileGeneratorStatusFilters,
  PollGetNormFileGeneratorStatuses,
  NormFileGeneratorStatusesResponse,
} from 'apps/marketplace/apiTypes/normFileGeneratorStatuses'
import { NormingJobsFilters } from './NormingJobsFilters'
import { NormingJobsPollingTable } from './NormingJobsPollingTable'

export const NormingJobsTab = () => {
  const [requestParams, setRequestParams] = useState<GetNormFileGeneratorStatusesQueryParams>({
    filters: {
      currentUser: true,
    },
    pageCount: 0,
  })

  const { data, loading } = useGetNormFileGeneratorStatuses({
    queryParams: {
      filters: requestParams.filters,
      pageCount: requestParams.pageCount,
    },
  })
  const { totalCount = 0 } = data || {}

  const [displayNorms, setDisplayNorms] = useState<NormFileGeneratorStatus[]>([])
  const [normCount, setNormCount] = useState<number>(totalCount)

  const setFilters = (filters: Partial<NormFileGeneratorStatusFilters>) =>
    setRequestParams({
      ...requestParams,
      filters: {
        ...requestParams.filters,
        ...filters,
      },
    })

  const buildTable = (data: NormFileGeneratorStatusesResponse | null, loading: boolean) => {
    const { normFileGeneratorStatuses = [], totalCount = 0 } = data || {}

    if (!loading) {
      if (normFileGeneratorStatuses !== displayNorms && normFileGeneratorStatuses.length > 0) {
        setDisplayNorms(normFileGeneratorStatuses)
        setNormCount(totalCount)
      }
    }

    return (
      <NormingJobsPollingTable
        loading={loading}
        displayNorms={displayNorms}
        requestParams={requestParams}
        totalCount={normCount}
        setRequestParams={setRequestParams}
      />
    )
  }
  const inlineMessage = 'Data on this page will now update every four seconds'

  return (
    <>
      <Box mb={2}>
        <NormingJobsFilters filters={requestParams.filters} setFilters={setFilters} />
      </Box>
      <Box mb={2}>
        <InlineMessage type={INLINE_MESSAGE_VARIANTS.INFO} message={inlineMessage} />
      </Box>
      <Box mb={2}>
        <PollGetNormFileGeneratorStatuses queryParams={requestParams} interval={4000}>
          {data => buildTable(data, loading)}
        </PollGetNormFileGeneratorStatuses>
      </Box>
    </>
  )
}
